import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import {
	ANALYTICS_SOURCE,
	BulkSpacePermissionsPage,
} from '@confluence/bulk-permissions/entry-points/BulkPermissions';
import { BulkAccessManagementPage } from '@confluence/bulk-permissions/entry-points/BulkAccess';
import { useSpaceRoleMode } from '@confluence/space-utils/entry-points/useSpaceRoleMode';

export const BulkSpacePermissionsRoute = () => {
	const { isRbacEnabled } = useSpaceRoleMode();

	return isRbacEnabled ? <BulkAccessManagementPage /> : <BulkSpacePermissionsPage />;
};

BulkSpacePermissionsRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
